module.exports = __webpack_public_path__ + "static/img/tz.d19a8ee9.svg";